import { LinkButton } from '@yes.technology/react-toolkit'
import { Optional, Record as RRecord, Unknown } from 'runtypes'
import { StyleMap } from 'site/Renderer/hooks/useStyleMap'

export type ActionButtonProps = {
  props: React.ComponentProps<typeof LinkButton> & {
    styleMap?: StyleMap
  }
}

export const ActionButtonTypeGuard = RRecord({
  styleMap: Optional(Unknown)
})
